// IMPORTS

// global
import { Network } from "../globals"

// INTERFACE

export default class LendingPoolRouterInterfaceConfig {
  public appId: number
  public asset1Id: number
  public intermediatebAssetId: number
  public asset2Id: number
  public market1AppId: number
  public market2AppId: number
  public pool1AppId: number
  public pool2AppId: number
  public opFarmAppId: number

  constructor(
    appId: number,
    asset1Id: number,
    intermediatebAssetId: number,
    asset2Id: number,
    market1AppId: number,
    market2AppId: number,
    pool1AppId: number,
    pool2AppId: number,
    opFarmAppId: number
  ) {
    this.appId = appId
    this.asset1Id = asset1Id
    this.intermediatebAssetId = intermediatebAssetId
    this.asset2Id = asset2Id
    this.market1AppId = market1AppId
    this.market2AppId = market2AppId
    this.pool1AppId = pool1AppId
    this.pool2AppId = pool2AppId
    this.opFarmAppId = opFarmAppId
  }
}

export const LendingPoolRouterInterfaceConfigs = {
  [Network.MAINNET]: [
    new LendingPoolRouterInterfaceConfig(1037326737, 31566704, 841157954, 386192725, 818182048, 818183964, 841170409, 870150391, 841189050), // USDC/GOBTC
    new LendingPoolRouterInterfaceConfig(1037327812, 31566704, 841157954, 386195940, 818182048, 818188286, 841170409, 870143131, 841189050), // USDC/GOETH
    new LendingPoolRouterInterfaceConfig(1037329564, 1, 841157954, 31566704, 818179346, 818182048, 855716333, 841170409, 841189050), // USDC/ALGO
    new LendingPoolRouterInterfaceConfig(1037329803, 31566704, 841157954, 900652777, 818182048, 900883415, 841170409, 900923609, 841189050), // USDC/BANK
    new LendingPoolRouterInterfaceConfig(1037330104, 1, 841157954, 386192725, 818179346, 818183964, 855716333, 870150391, 841189050), // ALGO/GOBTC
    new LendingPoolRouterInterfaceConfig(1037330316, 1, 841157954, 386195940, 818179346, 818188286, 855716333, 870143131, 841189050), // ALGO/GOETH
    new LendingPoolRouterInterfaceConfig(1037330537, 386192725, 841157954, 386195940, 818183964, 818188286, 870150391, 870143131, 841189050), // GOBTC/GOETH
  ],
  [Network.TESTNET]: [
    new LendingPoolRouterInterfaceConfig(1037251860, 386192725, 841157954, 386195940, 818183964, 818188286, 870150391, 870143131, 841189050), // bad config
  ],
}

// STRING CONTSTANTS

export const LENDING_POOL_ROUTER_INTERFACE_STRINGS = {
  market1_app_id: "market1_app_id",
  market2_app_id: "market2_app_id",
  lp_market_app_id: "lp_market_app_id",
  lending_manager_app_id: "lending_manager_app_id",
  pool_app_id: "pool_app_id",
  pool_manager_app_id: "pool_manager_app_id",
  op_farm_app_id: "op_farm_app_id",
  asset1_id: "asset1_id",
  asset2_id: "asset2_id",
  b_asset1_id: "b_asset1_id",
  b_asset2_id: "b_asset2_id",
  lp_asset_id: "lp_asset_id",

  swap_step_1: "swap_step_1",
  swap_step_2: "swap_step_2",
  swap_step_3: "swap_step_3",
}